// Module scope, not component state: per-component queues would still interleave.
const queues = new Map<string, Promise<unknown>>();

export function enqueueKeyedWrite<T>(
  key: string,
  run: () => Promise<T>
): Promise<T> {
  const result = (queues.get(key) ?? Promise.resolve()).then(run);
  const settled = result.then(
    () => {},
    () => {}
  );
  queues.set(key, settled);
  void settled.then(() => {
    if (queues.get(key) === settled) queues.delete(key);
  });
  return result;
}

export function resetKeyedWriteQueues(): void {
  queues.clear();
}
